import { ProductCategoryOptionDTO } from '@/api/dto/ProductCategoryOptionDTO';
import { ProductCategoryOption } from '@/models/entities/ProductCategoryOption';
import { CrudModule, IModuleState } from './CrudModule';
import { EntityType } from '@/store/entityModules/types';
import { SearchQueryFilters } from '@/models/filters/SearchQueryFilters';
import { GetterTree } from 'vuex';

class ProductCategoryOptionModule extends CrudModule<
  ProductCategoryOption,
  ProductCategoryOptionDTO
> {
  state: IModuleState<ProductCategoryOption, ProductCategoryOptionDTO> = {
    ...this.state,

    entityType: EntityType.PRODUCT_CATEGORY_OPTION,
    queryFilters: new SearchQueryFilters({}),
  };

  getters: GetterTree<
    IModuleState<ProductCategoryOption, ProductCategoryOptionDTO>,
    any
  > = {
    ...this.getters,

    getItem: state => (id: number) => {
      const item = state.items.find((i: ProductCategoryOption) => i.id === id);
      return item || null;
    },
  };
}

const productCategoryOptionsModule = new ProductCategoryOptionModule();
export default productCategoryOptionsModule;
